import contentStudioInstance from '@/utils/axiosContentStudio';

const folderUpdaters = {
  createFolder: async (name: string) => {
    const response = await contentStudioInstance.post('/api/v1/folders/', {
      name,
    });
    return response.data;
  },
};

export default folderUpdaters;
